import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Illustration } from '@node-space/ui-components'
import { SessionStatusCodes } from '../helpers/constants'
import { SessionStatusCode, UIConfig } from '../helpers/types'

export interface PageErrorProps {
  statusCode: SessionStatusCode
  uiConfig: UIConfig
}

export const SessionStatusView = ({ statusCode, uiConfig }: PageErrorProps) => {
  const { t } = useTranslation()

  const getStatusIcon = () => {
    switch (statusCode) {
      case SessionStatusCodes.NO_REFERENCE:
      case SessionStatusCodes.QUERY_ERROR:
        return <Illustration name="Prohibit" color="error" />
      case SessionStatusCodes.SIGNED:
        return <Illustration name="SealCheck" color="success" />
      default:
        return <Illustration name="Warning" color="warning" />
    }
  }

  return (
    <Box flex centerChildren gap={16}>
      {uiConfig?.isBranded && getStatusIcon()}
      <p {...(uiConfig?.isDarkMode && { className: 'text-white' })}>
        {t(`customerPendingAgreements.status.${statusCode}`)}
      </p>
    </Box>
  )
}
